import React from 'react'
import PropTypes from 'prop-types'
import { Menu, MenuItem } from '@material-ui/core'
import { Permitted } from 'components'
import constants from 'constants/index'

const KanbanCardMenu = ({
  anchorEl,
  onClose,
  onOpen,
  onDelete,
  onViewSource,
  showViewSource = false,
  hideDelete = false,
}) => {
  const handleOpen = () => {
    onClose()
    if (onOpen) onOpen()
  }

  const handleDelete = () => {
    onClose()
    onDelete()
  }

  const handleViewSource = () => {
    onClose()
    if (onViewSource) onViewSource()
  }

  return (
    <Menu
      anchorEl={anchorEl}
      open={Boolean(anchorEl)}
      onClose={onClose}
      getContentAnchorEl={null}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
    >
      <MenuItem onClick={handleOpen}>Detalhes</MenuItem>
      {showViewSource && (
        <MenuItem onClick={handleViewSource}>Ver origem</MenuItem>
      )}
      {!hideDelete && (
        <Permitted tag={constants.permissions.KANBAN_TASKS.DESTROY}>
          <MenuItem onClick={handleDelete}>Excluir</MenuItem>
        </Permitted>
      )}
    </Menu>
  )
}

KanbanCardMenu.propTypes = {
  anchorEl: PropTypes.object,
  onClose: PropTypes.func.isRequired,
  onOpen: PropTypes.func,
  onDelete: PropTypes.func.isRequired,
  onViewSource: PropTypes.func,
  showViewSource: PropTypes.bool,
  hideDelete: PropTypes.bool,
}

export default KanbanCardMenu
